import styled from 'styled-components'

import COLORS from '@colors'

export const Count = styled.div`
  background-color: ${COLORS.whiteA1};
  border-radius: 50%;
  color: ${COLORS.white};
  font-size: 10px;
  height: 16px;
  margin-left: 11px;
  padding: 2px 5.5px;
  width: 16px;
`

export const Option = styled.div`
  color: ${COLORS.whiteA1};
  display: flex;
  margin-bottom: 21px;
  cursor: pointer;
  user-select: none;

  svg {
    margin-right: 10px;
  }
`
export const ButtonContainer = styled.div`
  display: flex;
`
